import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/sign-in',
    name: 'Sign in',
    component: () => import(/* webpackChunkName: "sign-in" */ '../pages/SignInPage.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../pages/DashboardPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import(/* webpackChunkName: "projects" */ '../pages/ProjectsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import(/* webpackChunkName: "orders" */ '../pages/OrdersPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: () => import(/* webpackChunkName: "customers" */ '../pages/CustomersPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/customers/:customerId',
    name: 'Customer Details',
    component: () => import(/* webpackChunkName: "customer-details" */ '../pages/CustomerDetailsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/licenses',
    name: 'Licenses',
    component: () => import(/* webpackChunkName: "licenses" */ '../pages/LicensesPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/licenses/:licenseId',
    name: 'License Details',
    component: () => import(/* webpackChunkName: "license-details" */ '../pages/LicenseDetailsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/distributors',
    name: 'Distributors',
    component: () => import(/* webpackChunkName: "distributor-details" */ '../pages/DistributorsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/distributors/:customerId',
    name: 'Distributor Details',
    component: () => import(/* webpackChunkName: "distributor-details" */ '../pages/DistributorDetailsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/payments',
    name: 'Payments',
    component: () => import(/* webpackChunkName: "payments" */ '../pages/PaymentsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/integrations',
    name: 'Integrations',
    component: () => import(/* webpackChunkName: "integrations" */ '../pages/IntegrationsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ '../pages/SettingsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/export',
    name: 'Settings/Export',
    component: () => import(/* webpackChunkName: "settings/export" */ '../pages/SettingsPage/ExportPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router

router.beforeEach((to, from, next) => {
  // Clear alerts whenever the user is switching pages
  store.dispatch('alert/clear');

  const loggedIn = store.state.rubyIdent.status.loggedIn;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (loggedIn === false) {
      next({ path: '/sign-in' });
    } else {
      next();
    }
  }

  if (to.path === '/sign-in' && loggedIn) {
    // If the user is logged in, redirect to homepage.
    next({ path: '/' });
  }

  next();
});